import React from 'react';
import { Box, Stack, Typography } from '@mui/material';
// import PropTypes from 'prop-types';
import { HashLink } from 'react-router-hash-link';

import { useDevice } from '../hooks/useResponsive';

export default function BannerSection() {
  const { isMobile } = useDevice();

  const features = [
    {
      label: 'Buy Used Car',
      icon: '/assets/images/HomeMobile/car.png',
      pathName: '/allproducts',
    },
    {
      label: 'Inspect any Car',
      icon: '/assets/images/HomeMobile/inspect.png',
      pathName: '/inspection',
    },
    {
      label: 'Check History',
      icon: '/assets/images/HomeMobile/history.png',
      pathName: '/home#Whatsapp',
    },
  ];
  return (
    <>
      <Box
        sx={{
          mb: 5,
          width: { xs: '100%' },
          borderRadius: 0,
          overflow: 'hidden',
          // boxShadow: 3,
          bgcolor: '#121212',
          position: 'relative',
        }}
      >
        {/* Top Image */}
        <Box
          component="img"
          src={isMobile ? '/assets/images/HomeMobile/banner.webp' : '/assets/images/HomeMobile/webBanner.png'} // replace with your actual image path
          alt="Warranty Image"
          sx={{
            width: '100%',
            //   height: 120,
            objectFit: 'cover',
            display: 'block',
            borderRadius: '0px ',
          }}
        />
        {/* <Box
          sx={{
            position: 'absolute',
            // top: '34%',
            top: `${heroImageHeight}px`,
            width: '100%',
            height: '84px', // Adjust height as needed
            background: 'linear-gradient(to top, #121212, rgba(0, 0, 0, 0))',
            zIndex: 1,
          }}
        /> */}
        {/* Bottom content */}
        <Stack direction="row" spacing={2} px={5} justifyContent="center" sx={{ backgroundColor: '#111', py: 3 }}>
          {features.map((item, index) => (
            <HashLink key={index} smooth to={item.pathName} style={{ textDecoration: 'none' }}>
              <Box
                className="element"
                key={index}
                sx={{
                  width: 100,
                  height: 86,
                  borderRadius: '6.87px',
                  // border: '1px solid #2e2e2e',
                  // boxShadow: 'inset 0 0 12px rgba(255,255,255,0.04), 0 0 8px rgba(255,255,255,0.03)',
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  justifyContent: 'center',
                  textAlign: 'center',
                  px: 1,
                  //  backgroundColor: '#252525',
                  // backgroundImage: 'linear-gradient(to bottom, rgba(95, 95, 95, 0.75) 0%, rgba(17, 17, 17, 0.26) 6%, #1A1A1A 18%, #1C1C1C 51%, #1A1A1A 82%, rgba(17, 17, 17, 0.26) 94%, rgba(95, 95, 95, 0.75) 100%)',
                  borderTop: '0.858px solid #3E3E3E',
                  borderBottom: '0.858px solid #3E3E3E',

                  background:
                    'linear-gradient(180deg, rgb(82 80 80 / 75%) 0%, rgb(33 32 32 / 26%) 6.4%, #1A1A1A 17.65%, #1C1C1C 50.69%, #1A1A1A 82%,  rgb(33 33 33 / 26%) 94%, rgb(59 56 56 / 75%) 100%), #252525',
                  position: 'relative',
                }}
              >
                <Box
                  sx={{
                    position: 'absolute',
                    top: '5px',
                    left: 0,
                    width: '1px',
                    height: '84%',
                    zIndex: 2,

                    background:
                      'linear-gradient(to bottom, #252525, #988f8f, #faecec, #c0bdbd, #585858, #524545, #252525)',

                    pointerEvents: 'none',
                  }}
                />
                <Box
                  sx={{
                    position: 'absolute',
                    top: '5px',
                    right: 0,
                    width: '0.858px',
                    height: '84%',
                    background:
                      'linear-gradient(to bottom, #252525, #988f8f, #faecec, #c0bdbd, #585858, #524545, #252525)',

                    pointerEvents: 'none',
                  }}
                />
                <Box component="img" src={item.icon} alt={item.label} sx={{ objectFit: 'cover', height: 29, mb: 1 }} />
                <Typography variant="body2" sx={{ color: '#FFFFFFDE', fontSize: 10, fontWeight: 500 }}>
                  {item.label}
                </Typography>
              </Box>
            </HashLink>
          ))}
        </Stack>
      </Box>
    </>
  );
}

BannerSection.propTypes = {
  // heroImageHeight: PropTypes.number.isRequired,
};
